import { useEffect, useRef } from "react";

const facebookEmbeds = [
  // Post más reciente
  `<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid0LYraz5mcSkYiW7LMemwGrA7KmA4wsCu5k8qQUx21QDEa9tJMQ3gPQByHDmkiz8c3l%26id%3D61586569725415&show_text=true&width=500" width="500" height="498" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>`,

  // Post medio
  `<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid033gfAGLoxB5sDn8DgwFyfJdbtEiN9HfMSuJohWA9xTVk5egMQLQCtknZJcSxUzRRtl%26id%3D61586569725415&show_text=true&width=500" width="500" height="717" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>`,

  // Post más antiguo
  `<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid02TBiCX4ZEb1azkT5bhUQripd7wYYS6q7emnBwxegy1GjZSsR49JaKBUXHp79E9uFcl%26id%3D61586569725415&show_text=true&width=500" width="500" height="700" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>`,
];

declare global {
  interface Window {
    FB?: {
      XFBML: {
        parse: (element?: HTMLElement) => void;
      };
    };
    fbAsyncInit?: () => void;
  }
}

export default function FacebookFeed() {
  const sdkLoaded = useRef(false);

  useEffect(() => {
    if (!sdkLoaded.current && !document.getElementById("facebook-jssdk")) {
      // Inicializar el SDK de Facebook
      const script = document.createElement("script");
      script.id = "facebook-jssdk";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      script.src = "https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v22.0";
      script.onload = () => {
        if (window.FB) {
          window.FB.XFBML.parse();
        }
      };
      document.body.appendChild(script);
      sdkLoaded.current = true;
    } else if (window.FB) {
      window.FB.XFBML.parse();
    }
  }, []);

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      {/* Encabezado */}
      <div className="flex items-center justify-between px-5 md:px-6 py-3 md:py-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-social-facebook flex items-center justify-center text-white text-lg">
            <i className="ri-facebook-fill" />
          </div>
          <div>
            <span
              className="text-masmed-gray-800 text-base md:text-lg"
              style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 600 }}
            >
              Facebook
            </span>
            <p className="text-masmed-gray-400 text-xs">MásMed Tarapacá</p>
          </div>
        </div>
        <a
          href="https://www.facebook.com/profile.php?id=61586569725415"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-4 py-2 bg-social-facebook text-white text-sm rounded-md hover:opacity-90 transition-opacity duration-200 cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 600 }}
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-facebook-fill" />
          </span>
          Seguir
        </a>
      </div>

      {/* Grid de posts embebidos */}
      <div className="p-4 md:p-5 bg-masmed-gray-50">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {facebookEmbeds.map((embedHtml, i) => (
            <div key={i} className="flex justify-center">
              <div
                className="w-full max-w-[500px]"
                dangerouslySetInnerHTML={{ __html: embedHtml }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}